/**
 * /en/admin/structure/paragraphs_type/slot_unavailable_modal/fields
 */

import { DOM_EVENTS, SEARCH_PARAM_KEYS, SESSION_STORAGE_KEYS, WORKFLOWS } from "@js/constants/constants-imports.es6.js";
import Field from "@js/core/field.es6.js";
import ModalParagraph from "@js/paragraphs/modal-paragraph.es6.js";
import UrlUtils from "@js/utils/url-utils.es6.js";

export default class SlotUnavailableModalParagraph extends ModalParagraph {
  constructor({ parentElement }) {
    super({
      machineName: 'slot_unavailable_modal',
      parentElement,
    });
  }

  get chooseAnotherTimeButton() {
    return new Field({
      machineName: 'field_primary_button',
      parentElement: this,
    });
  }

  initialize() {
    this.#updateChooseAnotherTimeButton();
  }

  #updateChooseAnotherTimeButton() {
    const $chooseAnotherTimeButton = this.chooseAnotherTimeButton.$();
    $chooseAnotherTimeButton.on(DOM_EVENTS.CLICK, (event) => {
      event.preventDefault();

      // Make sure the next page does not use cached results.
      sessionStorage.removeItem(SESSION_STORAGE_KEYS.PROVIDER_ALL_SLOTS);

      // This is how we tell the next page that the user needs to be taken to slot selection section of the screen
      // after the results are reloaded.
      UrlUtils.updateSearchParameter(SEARCH_PARAM_KEYS.WORKFLOW, WORKFLOWS.SELECT_NEW_TIME, false);

      // Reloads scheduling results.
      window.location.reload();
    });
  }
}
